import { Keypair } from '@solana/web3.js'

export const randomKeyPair = Keypair.generate()
